export const DocType = {
  ACHAT: 'ACHAT',
  VENTE: 'VENTE',
}

export const PositionTransaction = {
  EMETTEUR: 'EMETTEUR',
  RECEPTEUR: 'RECEPTEUR',
}
